module.exports = __webpack_public_path__ + "static/media/Paula-II-Raven--ED.726f43bf.jpg";